import { followUps } from "@/mocks/freegua";

export default function FollowUp() {
  return (
    <section id="follow" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-bold text-accent-800">
              <i className="ri-refresh-line" aria-hidden="true" />
              事件进行中
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              正在持续跟进的这则瓜
            </h2>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-foreground-600">
              从第一波截图到每一轮后续回应，都按真实时间挂在时间线上。中间漏掉的那几环，回来接着往下看就补上了，不收藏也不怕断。
            </p>

            <ol className="mt-8 space-y-0">
              {followUps.map((f, i) => (
                <li key={f.title} className="relative flex gap-4 pb-7 last:pb-0">
                  {i < followUps.length - 1 && (
                    <span className="absolute left-[11px] top-6 h-full w-px bg-background-200" aria-hidden="true" />
                  )}
                  <span className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-background-50 ring-2 ring-accent-500">
                    <span className="h-2 w-2 rounded-full bg-accent-500" />
                  </span>
                  <div className="min-w-0 flex-1 rounded-2xl border border-background-200/80 bg-background-100 p-4">
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                      <time className="whitespace-nowrap font-label text-xs font-bold text-accent-700">{f.time}</time>
                      <h3 className="text-base font-extrabold text-foreground-950">{f.title}</h3>
                      <span className="ml-auto whitespace-nowrap rounded-full bg-background-50 px-2.5 py-0.5 text-[11px] font-bold text-foreground-600">
                        {f.mark}
                      </span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.body}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <div className="relative overflow-hidden rounded-2xl border border-background-200/80">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20minimal%20editorial%20photo%20of%20a%20smartphone%20showing%20chat%20timeline%20lying%20on%20cream%20notebook%20with%20watermelon%20and%20coffee%2C%20beige%20background%2C%20soft%20light%2C%20gossip%20updates%20archiving%20mood%2C%20clean%20cozy%20composition%2C%20high%20detail&width=1200&height=1100&seq=gua-follow&orientation=portrait"
              alt="持续跟进的吃瓜时间线素材配图"
              className="h-full w-full object-cover"
            />
            <div className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1.5 text-xs font-bold text-primary-700 backdrop-blur">
              <i className="ri-live-line mr-1" aria-hidden="true" />
              素材持续更新中
            </div>
            <div className="absolute bottom-4 left-4 right-4 rounded-2xl border border-background-200/60 bg-background-50/90 p-4 backdrop-blur">
              <p className="text-sm font-semibold text-foreground-900">「本则瓜现有 4 个阶段整理完毕」</p>
              <p className="mt-1 text-xs text-foreground-500">
                起点、回应、整理、佐证逐段推进，免费吃瓜零元看，后续回应还会继续补充。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}